import { gql } from '@apollo/client';

export const REJECT_PROSPECT = gql`
  mutation RejectClient(
    $rejectClientId: String!
    $isPermanetReject: Boolean!
    $rejectClientInfo: RejectClientInfoInput!
  ) {
    rejectClient(
      id: $rejectClientId
      isPermanetReject: $isPermanetReject
      rejectClientInfo: $rejectClientInfo
    ) {
      rejections {
        reason
        internalReason
        contactData
        economicData
        personalData
        status
        type
      }
    }
  }
`;
